import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/admin/owners")({
  staticData: { title: "Owners" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/admin/owners/page.tsx"),
    "OwnersPage",
  ),
})
